import type { IconTileData } from './types';

interface IconTileProps {
  data: IconTileData;
}

export function IconTile({ data }: IconTileProps) {
  const { label, icon, anchorId } = data;

  const content = (
    <>
      <span className='text-sm font-semibold md:text-center text-balanced'>{label}</span>
      {icon && (
        <img
          src={icon.src}
          alt={icon.alt ?? ''}
          className=''
        />
      )}
    </>
  );

  if (!anchorId) {
    return (
      <div className='rounded-lg border-2 border-secondary-500 p-4 flex flex-col items-center'>
        {content}
      </div>
    );
  }

  return (
    <a
      href={`#${anchorId}`}
      className='rounded-lg border-2 border-secondary-500 p-2 flex flex-col items-center text-center'
    >
      {content}
    </a>
  );
}
